import { useState } from 'react';
import { Button, Card, Space, Typography, message } from 'antd';
import { DownloadOutlined, FilePdfOutlined } from '@ant-design/icons';
import hepatoApi from '../../api/hepatoApi';
import DocumentLanguageSelector from '../../components/common/DocumentLanguageSelector';
import { useDocumentLanguage } from '../../hooks/useDocumentLanguage';
import { DOCUMENT_LANGUAGE_HINTS, DOCUMENT_LANGUAGE_LABELS } from '../../hooks/useLanguage';

const { Text } = Typography;

/** Export PDF complet hepato (anamneză + toți pașii clinici), în limba documentului aleasă. */
const HepatoExportActions = ({ formId }: { formId: string | null }) => {
  const { language } = useDocumentLanguage();
  const [loading, setLoading] = useState(false);

  if (!formId) return null;

  const download = async () => {
    try {
      setLoading(true);
      const blob = await hepatoApi.downloadFullPdf(formId, language);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `HEPASKIN_Hepato_Complet_${DOCUMENT_LANGUAGE_LABELS[language].short}_${new Date().toISOString().split('T')[0]}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      message.success(`PDF complet descărcat (${DOCUMENT_LANGUAGE_LABELS[language].native})`);
    } catch (e: any) {
      message.error(e?.response?.data?.message ?? 'Eroare la descărcarea PDF-ului');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      size="small"
      style={{ marginBottom: 12, borderColor: '#91caff' }}
      data-testid="hepato-export"
      title={
        <Space>
          <FilePdfOutlined style={{ color: '#cf1322' }} />
          <span>Export PDF — {DOCUMENT_LANGUAGE_LABELS[language].native}</span>
        </Space>
      }
    >
      <Space wrap>
        <Button type="primary" icon={<DownloadOutlined />} loading={loading} onClick={() => void download()}>
          Fișă completă (pașii 1–12)
        </Button>
        <DocumentLanguageSelector id="hepato-document-language" />
      </Space>
      <div style={{ marginTop: 8 }}>
        <Text type="secondary" style={{ fontSize: 12 }}>
          {DOCUMENT_LANGUAGE_HINTS[language] ?? 'Limba documentului PDF (RO / EN / SRB).'}
        </Text>
      </div>
    </Card>
  );
};

export default HepatoExportActions;
